import { getDocumentElements, getScrollTop, getScrollLeft, isChildOf } from '../utils'

const [tooltips] = getDocumentElements([{ className: 'js-tet-tooltip', getAllElements: true }])

const style = document.createElement('style')
document.head.appendChild(style)
const classes = [
    'tet-tooltip__inner-top',
    'tet-tooltip__inner-bottom',
    'tet-tooltip__inner-right',
    'tet-tooltip__inner-left',
    'tet-tooltip__inner-custom',
    'tet-tooltip__inner-custom--br',
    'tet-tooltip__inner-custom--tr',
    'tet-tooltip__inner-custom--bl',
    'tet-tooltip__inner-custom--tl'
];

const init = () => {
    if (tooltips) {
        const showTooltip = e => {
            e.target.classList.add('active')

            const tooltipContent = e.target.getElementsByClassName('tet-tooltip__inner')[0]

            const tooltipLeft = e.target.getBoundingClientRect().left
            const tooltipTop = e.target.getBoundingClientRect().top
            const tooltipRight = e.target.getBoundingClientRect().right
            const tooltipBottom = e.target.getBoundingClientRect().bottom
            const tooltipHeight = e.target.getBoundingClientRect().height
            const tooltipWidth = e.target.getBoundingClientRect().width
            const tooltipContentHeight = tooltipContent.getBoundingClientRect().height
            const tooltipContentWidth = tooltipContent.getBoundingClientRect().width

            const windowWidth = window.innerWidth
            const windowHeight = window.innerHeight

            const half = tooltipContentHeight / 2 - tooltipHeight / 2

            const errorMargin = 10
            const spacing = 14
            const spacingSystem = 7
            const tooltipArrow = 16
            const mobilePaddings = 16

            style.innerHTML = ``
            if (tooltipContent.classList.contains('tet-tooltip__inner-system')) {
                if (
                    // Top
                    tooltipTop > tooltipContentHeight + errorMargin &&
                    tooltipContentWidth / 2 - tooltipWidth / 2 < tooltipLeft &&
                    tooltipContentWidth / 2 - tooltipWidth / 2 <
                        windowWidth - (tooltipLeft + tooltipWidth)
                ) {
                    tooltipContent.style.left = `${tooltipLeft - (tooltipContentWidth / 2 - tooltipWidth / 2)}px`
                    tooltipContent.style.top = `${tooltipTop - tooltipContentHeight - spacingSystem}px`
                } else if (
                    // Bottom
                    windowHeight - tooltipBottom > tooltipContentHeight + errorMargin &&
                    tooltipContentWidth / 2 - tooltipWidth / 2 < tooltipLeft &&
                    tooltipContentWidth / 2 - tooltipWidth / 2 <
                        windowWidth - (tooltipLeft + tooltipWidth)
                ) {
                    tooltipContent.style.left = `${tooltipLeft - (tooltipContentWidth / 2 - tooltipWidth / 2)}px`
                    tooltipContent.style.top = `${tooltipTop + tooltipHeight + spacingSystem}px`
                } else if (
                    // Right
                    windowWidth - tooltipLeft > tooltipContentWidth + errorMargin &&
                    half < tooltipTop &&
                    half < windowHeight - tooltipBottom
                ) {
                    tooltipContent.style.top = `${tooltipTop}px`
                    tooltipContent.style.left = `${tooltipLeft + tooltipWidth + spacingSystem}px`
                } else if (
                    // Left
                    tooltipLeft > tooltipContentWidth + errorMargin &&
                    half < tooltipTop &&
                    half < windowHeight - tooltipBottom
                ) {
                    tooltipContent.style.top = `${tooltipTop}px`
                    tooltipContent.style.left = `${tooltipLeft - tooltipContentWidth - spacingSystem}px`
                }
            } else {
                    // If elements is inside modal
                if (isChildOf(e.target, document.querySelector('.js-tet-modal'))) {
                    let modalTop = 0;
                    windowWidth > 479 ? modalTop = 80 : modalTop = 72;
                    if (tooltipTop > tooltipContentHeight + errorMargin) {
                        // Top
                        if (tooltipContent.classList.contains('tet-tooltip__inner-small')) {
                            tooltipContent.style.width = `${tooltipContentWidth}px`
                        } else {
                            tooltipContent.style.width = `${windowWidth - tooltipArrow}px`
                        }
                        tooltipContent.classList.add('tet-tooltip__inner-top')
                        tooltipContent.style.left = 0
                        tooltipContent.style.top = `${-modalTop + tooltipTop - tooltipContentHeight - spacing}px`
                        style.innerHTML = `.tet-tooltip--dark .tet-tooltip__inner:after { content: none; } .tet-tooltip__inner:after { content: none; }`
                    }
                    else if (
                        windowHeight - tooltipBottom >
                        tooltipContentHeight + errorMargin
                    ) {
                        // Bottom
                        if (tooltipContent.classList.contains('tet-tooltip__inner-small')) {
                            tooltipContent.style.width = `${tooltipContentWidth}px`
                        } else {
                            tooltipContent.style.width = `${windowWidth - tooltipArrow}px`
                        }
                        tooltipContent.classList.add('tet-tooltip__inner-bottom')
                        tooltipContent.style.left = 0
                        tooltipContent.style.top = `${-modalTop + tooltipTop + spacing}px`
                        style.innerHTML = `.tet-tooltip--dark .tet-tooltip__inner:after { content: none; } .tet-tooltip__inner:after { content: none; }`
                    }
                } else {
                    if (windowWidth > 479) {
                        if (
                            // Top
                            tooltipTop > tooltipContentHeight + errorMargin &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 < tooltipLeft &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 <
                                windowWidth - (tooltipLeft + tooltipWidth)
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-top')
                            tooltipContent.style.left = `${tooltipLeft - (tooltipContentWidth / 2 - tooltipWidth / 2)}px`
                            tooltipContent.style.top = `${tooltipTop - tooltipContentHeight - spacing}px`
                        } else if (
                            // Bottom
                            windowHeight - tooltipBottom > tooltipContentHeight + errorMargin &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 < tooltipLeft &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 <
                                windowWidth - (tooltipLeft + tooltipWidth)
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-bottom')
                            tooltipContent.style.left = `${tooltipLeft - (tooltipContentWidth / 2 -
                                tooltipWidth / 2)}px`
                            tooltipContent.style.top = `${tooltipTop + tooltipHeight + spacing}px`
                        } else if (
                            // Right
                            windowWidth - tooltipLeft > tooltipContentWidth + errorMargin &&
                            half < tooltipTop &&
                            half < windowHeight - tooltipBottom
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-right')
                            tooltipContent.style.left = `${tooltipLeft + tooltipWidth + spacing}px`
                            tooltipContent.style.top = `${tooltipTop + (tooltipHeight / 2 -
                                tooltipContentHeight / 2)}px`
                        } else if (
                            // Left
                            tooltipLeft > tooltipContentWidth + errorMargin &&
                            half < tooltipTop &&
                            half < windowHeight - tooltipBottom
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-left')
                            tooltipContent.style.left = `${tooltipLeft - tooltipContentWidth - spacing}px`
                            tooltipContent.style.top = `${tooltipTop + (tooltipHeight / 2 -
                                tooltipContentHeight / 2)}px`
                        } else if (
                            // Bottom Right
                            tooltipTop < tooltipContentHeight + errorMargin &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 > tooltipLeft &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 <
                                windowWidth - (tooltipLeft + tooltipWidth) &&
                            windowHeight - tooltipBottom > tooltipContentHeight
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-custom--br')
                            tooltipContent.style.left = `${tooltipLeft - spacing}px`
                            tooltipContent.style.top = `${tooltipTop + tooltipHeight + spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${(tooltipWidth / 2) + spacing  - (tooltipArrow / 2)}px;
                            }`
                        } else if (
                            // Bottom Left
                            tooltipTop < tooltipContentHeight + errorMargin &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 < tooltipLeft &&
                            tooltipContentWidth / 2 - tooltipWidth / 2 >
                                windowWidth - (tooltipLeft + tooltipWidth) &&
                            windowHeight - tooltipBottom > tooltipContentHeight
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-custom--bl')
                            tooltipContent.style.left = `${tooltipLeft - tooltipContentWidth + tooltipWidth + spacing}px`
                            tooltipContent.style.top = `${tooltipTop + tooltipHeight + spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${tooltipContentWidth - (tooltipWidth / 2) - (tooltipArrow / 2) - spacing}px;
                            }`
                        } else if (
                            // Top Right
                            windowHeight - tooltipBottom < tooltipContentHeight + errorMargin &&
                            tooltipLeft < tooltipContentWidth &&
                            windowWidth - tooltipLeft > tooltipContentWidth &&
                            tooltipTop > tooltipContentHeight
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-custom--tr')
                            tooltipContent.style.left = `${tooltipLeft - spacing}px`
                            tooltipContent.style.top = `${tooltipTop - tooltipContentHeight - spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${(tooltipWidth / 2) + spacing  - (tooltipArrow / 2)}px;
                            }`
                        } else if (
                            // Top Left
                            windowHeight - tooltipBottom < tooltipContentHeight + errorMargin &&
                            tooltipLeft > tooltipContentWidth &&
                            windowWidth - tooltipLeft < tooltipContentWidth &&
                            tooltipTop > tooltipContentHeight
                        ) {
                            tooltipContent.classList.add('tet-tooltip__inner-custom--tl')
                            tooltipContent.style.left = `${tooltipLeft - tooltipContentWidth + tooltipWidth + spacing}px`
                            tooltipContent.style.top = `${tooltipTop - tooltipContentHeight - spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${tooltipContentWidth - (tooltipWidth / 2) - (tooltipArrow / 2) - spacing}px;
                            }`
                        }
                    } else {
                        if (tooltipTop > tooltipContentHeight + errorMargin) {
                            // Top
                            if (tooltipContent.classList.contains('tet-tooltip__inner-small')) {
                                tooltipContent.style.width = `${tooltipContentWidth}px`
                            } else {
                                tooltipContent.style.width = `${windowWidth - tooltipArrow}px`
                            }
                            tooltipContent.classList.add('tet-tooltip__inner-top')
                            tooltipContent.style.left = `${tooltipArrow / 2}px`
                            tooltipContent.style.top = `${tooltipTop - tooltipContentHeight - spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${tooltipLeft + (tooltipWidth / 2) - mobilePaddings}px;
                            }`
                        }
                        else if (
                            windowHeight - tooltipBottom >
                            tooltipContentHeight + errorMargin
                        ) {
                            // Bottom
                            if (tooltipContent.classList.contains('tet-tooltip__inner-small')) {
                                tooltipContent.style.width = `${tooltipContentWidth}px`
                            } else {
                                tooltipContent.style.width = `${windowWidth - tooltipArrow}px`
                            }
                            tooltipContent.classList.add('tet-tooltip__inner-bottom')
                            tooltipContent.style.left = `${tooltipArrow / 2}px`
                            tooltipContent.style.top = `${tooltipTop + tooltipHeight + spacing}px`
                            style.innerHTML = `.tet-tooltip__inner:after {
                                left: ${tooltipLeft + (tooltipWidth / 2) - mobilePaddings}px;
                            }`
                        }
                    }
                }
            }
        }

        const hideTooltip = e => {
            e.target.classList.remove('active')
            const tooltipContent = e.target.getElementsByClassName('tet-tooltip__inner')[0]
            tooltipContent.classList.remove(classes)
            tooltipContent.style.animation = 'fadeOut 75ms ease-in'
            setTimeout(() => {
                tooltipContent.style = ''
            }, 100)
        }

        Array.from(tooltips).map(tooltips => {
            tooltips.addEventListener('click', showTooltip)
            tooltips.addEventListener('mouseenter', showTooltip)
            tooltips.addEventListener('mouseleave', hideTooltip)
        })       

        window.addEventListener('scroll', (e) => {
            Array.from(tooltips).map(tooltips => {
                if (tooltips.classList.contains('active')) {
                    tooltips.classList.remove('active')
                    const tooltipContent = tooltips.getElementsByClassName('tet-tooltip__inner')[0]
                    tooltipContent.classList.remove(classes)
                    tooltipContent.style.animation = 'fadeOut 75ms ease-in'
                    setTimeout(() => {
                        tooltipContent.style = ''
                    }, 100)
                }
            })
        })
    }
}

export { init }
